<template>
	<DropdownStatus
		:options="assistantOptions"
		id="assistant-dropdown"
		optionLabel="label"
		optionValue="value"
		:placeholder="null"
		@change="onAssistantSelect"
		class="assistant-dropdown !p-0 !m-0 rounded-full border !border-danger !focus:border-danger !active:border-danger !outline-danger"
		
		
	>
		<template #value>
			<i class="i-fa6-solid:people-arrows !p-0 !m-0 text-size-xl color-danger block" v-tooltip.bottom="'Available Assistants'"></i>
		</template>
		<template #dropdownicon></template>

		<template #option="slotProps">
			<EditButton
				:id="callout.identifier"
				:type="slotProps.option.value"
				:headerTitle="slotProps.option.headerTitle"
				:overrideURL="slotProps.option.url"
				:buttonLabel="slotProps.option.label"
				:class="['w-full text-right gap-2', slotProps.option.class]"
			/>
		</template>
	</DropdownStatus>
</template>

<script setup lang="ts">
import { computed } from "vue";
import EditButton from "@/components/EditButton.vue";

const props = defineProps<{
	callout: any;
	AppConfig: any;
	showhelpSupportAssistantButton?: boolean;
	showassistantComplainceButton?: boolean;
	showassistantReportButton?: boolean;
	showFeedbackassistantButton?: boolean;
	showCallAssistantButton?: boolean;
}>();

const assistantOptions = computed(() => {
	const opts: { label: string; url: string; value: string; class: string, headerTitle?:string; }[] = [];

	if (props.showhelpSupportAssistantButton) {
		opts.push({
			label: "Help Support Assistant",
			headerTitle:props.callout.mainOutcome.title,
			value: "helpSupportAssistant",
			url: props.callout._links?.helpSupportAssistantLink?.href,
			class:'rounded items-center p-2 text-center font-sans text-md hover:text-info-500  !text-info',
		});
	}
	if (props.showassistantComplainceButton) {
		opts.push({
			label: "Compliance Assistant",
			headerTitle:props.callout.mainOutcome.title,
			value: "complainceAssistantMode",
			url: props.callout._links?.compliancyAssistantLink?.href,
			class:'rounded items-center p-2 text-center font-sans text-md hover:text-success-500 !text-success',

		});
	}
	if (props.showassistantReportButton) {
		opts.push({
			label: "Reporting Assistant",
			headerTitle:props.callout.mainOutcome.title,
			value: "reportassistantMode",
			url: props.callout._links?.reportingAssistantLink?.href,
			class:'rounded items-center p-2 text-center font-sans text-md hover:text-success-500  !text-warning',

		});
	}
	if (props.showFeedbackassistantButton) {
		opts.push({
			label: "Feedback Assistant",
			headerTitle:props.callout.mainOutcome.title,
			value: "feedbackAssistantMode",
			url: props.callout._links?.feedbackAssistantLink?.href,
			class:'rounded items-center p-2 text-center font-sans text-md hover:text-primary-100 !text-primary',

		});
	}
	if (props.showCallAssistantButton) {
		opts.push({
			label: "Examiner Assistant",
			headerTitle:props.callout.mainOutcome.title,
			value: "examinerAssistantMode",
			url: props.callout._links?.examinerAssistantLink?.href,
			class:'rounded items-center p-2 text-center font-sans text-md hover:text-secondary-500 !text-dark',

		});
	}

	return opts;
});

function onAssistantSelect(option: any) {
	// opsionale, mund të mos duhet fare
	if (option?.url) {
		window.location.href = option.url;
	}
}
</script>
<style>
#assistant-dropdown .p-dropdown-trigger {
	display:none!important
}

#assistant-dropdown .p-inputtext {
  padding: 0.5rem !important;
}
#assistant-dropdown_list .p-dropdown-item {
  padding: 0rem !important;
}
#assistant-dropdown .p-dropdown-items .p-dropdown-item span {
  margin-left: 0.5rem;
}


</style>
